import React from 'react';
import './App.css';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ShopApp from './components/ShopApp';
import PrizePage from './components/PrizePage';
import ClaimPage from './components/ClaimPage';

function App() {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/" element={<ShopApp />} />
          <Route path="/prize" element={<PrizePage />} />
          <Route path="/claim" element={<ClaimPage />} />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'var(--tg-theme-secondary-bg-color)',
              color: 'var(--tg-theme-text-color)',
              border: '1px solid var(--tg-theme-hint-color)',
              borderRadius: '12px',
              fontSize: '14px',
              fontWeight: '500',
              maxWidth: '400px',
              padding: '12px 16px',
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: 'var(--tg-theme-bg-color)',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: 'var(--tg-theme-bg-color)',
              },
            },
            loading: {
              iconTheme: {
                primary: 'var(--tg-theme-button-color)',
                secondary: 'var(--tg-theme-bg-color)',
              },
            },
          }}
        />
      </>
    </Router>
  );
}

export default App;
